import React from "react";
import { useNavigate } from "react-router-dom";
import {
  FlexColumn,
  FlexItem,
  FlexRow,
  FlexRowSpaced,
  FlexSpacer,
} from "@components/layout/FlexStyles";
import { TextRegular, TextTitle, TextSmallItalics } from "@components/elements/TextStyles";
import TextButton from '@components/controls/TextButton';

const debug = false;
const SubmissionsStatus = ({ status, newForm }) => {
  debug && console.log("SubmissionsStatus | status", status);

  const navigate = useNavigate();

  return (
    <FlexColumn h_centered>
      <FlexItem>
        <TextTitle color={'accent'}>Successfully Submitted Your Request for Analysis!</TextTitle>
      </FlexItem>
      <FlexRow height={"20px"}></FlexRow>
      <FlexRow>
        <FlexItem>
          <TextRegular color={'primary'}>Submission number: </TextRegular>
        </FlexItem>
        <FlexSpacer width={4} />
        <FlexItem>
          <TextRegular color={"accent"}>{status.documentId}</TextRegular>
        </FlexItem>
        <FlexSpacer width={4} />
        <FlexItem>
          <TextRegular color={'primary'}> is being processed...</TextRegular>
        </FlexItem>
      </FlexRow>
      <FlexRow height={"20px"}></FlexRow>
      <FlexRow h_centered>
        <FlexItem width={'80%'}>
          <TextRegular>This pending request will be shown in your submissions list. It will be shown as pending until complete.
            Once complete, you will see the score and be able to download the report. </TextRegular>
        </FlexItem>
      </FlexRow>
      <FlexRow height={"20px"}></FlexRow>
      <FlexRow>
        <FlexItem>
          <TextSmallItalics>(average compute time for an analysis is 15s to 2 minutes).</TextSmallItalics>
        </FlexItem>
      </FlexRow>
      <FlexRow height={"40px"}></FlexRow>
      <FlexRowSpaced width={"250px"}>
        <TextButton
          width={120}
          label={"See Details"}
          onClick={() => navigate(`/submissions/${status.documentHash}`)}
        />
        <TextButton
          width={120}
          label={"Submissions List"}
          onClick={() => navigate(`/submissions`)}
        />
        <TextButton
          width={120}
          label={"New Submission"}
          onClick={() => newForm()}
        />
      </FlexRowSpaced>
    </FlexColumn>
  );
};

export default SubmissionsStatus;
